// @ts-nocheck

import { createContext, useContext } from 'react';

type ParentTriggererContextProps = {
  parentTriggerer?: string | null;
};

export const ParentTriggererContext = createContext<ParentTriggererContextProps>({
  parentTriggerer: null,
});

export const useParentTriggererContext = () => useContext(ParentTriggererContext);
